import { render, staticRenderFns } from "./PendingTickets.vue?vue&type=template&id=61715cc8"
import script from "./PendingTickets.vue?vue&type=script&lang=js"
export * from "./PendingTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports